import '@hotwired/turbo-rails';
import '~/c/controllers/desktop';
import '~/c/turbo_streams/redirect';

//only for aga sidebar
import { global } from '~/c/desktop/modules/global';

document.addEventListener('turbo:load', () => {
  global();
})
